/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Logo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import BrandLogo from 'DesignSystem/BrandLogo/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Logo({
  children,
  viewPath = "/App/Account/Content/Menu/Logo"
  
}) {
let accountUserVaxiomPersonPrimaryLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'account',
path: 'user.vaxiom_person.primary_location_id',
})
  return (<React.Fragment
>
<BrandLogo
  viewPath={`${viewPath}/BrandLogo`}
 data="account.user.vaxiom_person.primary_location_id"
 locationId={accountUserVaxiomPersonPrimaryLocationIdValueData}
/>
{children}
</React.Fragment>)
}